import { put, call, takeLatest } from 'redux-saga/effects';
import * as actions from '../../common/actions/startPageActions';
import { generateRotpTokenAsync, redirectToGuestPaymentProcessor } from '@/common/apis/paymentsV2Api'
import { Exception } from '../../common/constants/exception';

export function* generateRotpToken(action) {
  yield put(actions.loadInvoicePending());

  try {
    const guestTokenResponse  = yield call(generateRotpTokenAsync, action.payload.invoiceNum, action.payload.invoiceAmt, action.payload.loadNum, action.payload.token, action.payload.recaptchaType);
    yield put(actions.generateRotpTokenSuccess());
    yield call(redirectToGuestPaymentProcessor, guestTokenResponse.rotpToken);
  } catch (error:any) {
    // Map to servicestack error format for backward compatibility with error handling
    const ex: Exception = {
      response: {
        status: error.response.status,
        data: {
          responseStatus: {
            message: error.response.data,
            stackTrace: ''
          }
        }
      }
    }

    const errorAction = getInvoiceSearchErrorAction(ex, action.payload.recaptchaType);
    yield put(errorAction);
  }
}

function getInvoiceSearchErrorAction(error: Exception, recaptchaType: string) {
  if (error.response && error.response.status) {
    if (error.response.status === 404) {
      return actions.loadInvoiceNotFound(error);
    } else if (error.response.status === 403 ) {
      return actions.loadInvoiceForbidden(error);
    } else if (error.response.status === 400 && error.response.data?.responseStatus?.message === "Invoice currency must be USD.") {
      return actions.loadInvoiceNotUsd(error);
    } else if (error.response.status === 400 && error.response.data?.responseStatus?.message) {
       return actions.loadInvoiceValidationError(error);
    } else if (error.response.status === 401 && recaptchaType === "reCaptchaV3"){
      return actions.reAuthenticate();
    } else if (error.response.status === 401 ) {
       return actions.loadInvoiceForbidden(error);
    } else {
      return actions.loadInvoiceFailure(error);
    }
  } else {
    return actions.loadInvoiceFailure(error);
  }
}

export function* watchGenerateRotpToken() {
  yield takeLatest('SUBMIT_GENERATE_ROTP_TOKEN', generateRotpToken);
}
